import { DownloadIcon } from '@radix-ui/react-icons'
import { useKestrel } from 'features/kestrelViewer'
import { DownloadDefectsReportWithScreenshots } from 'features/kestrelViewer/ui/tools/exportControls/DownloadDefectsReportWithScreenshots'
import { DownloadIndicationsPDF } from 'features/kestrelViewer/ui/tools/exportControls/DownloadIndicationsPDF'
import { DownloadStepFileButton } from 'features/kestrelViewer/ui/tools/exportControls/DownloadStepFileButton'
import { SubmenuComponent } from 'features/kestrelViewer/ui/tools/SubmenuComponent'
import React from 'react'

export const ExportControlsSubmenu: React.FC = () => {
  const { gatekeeper } = useKestrel()

  return (
    <SubmenuComponent
      label='Export Controls'
      icon={<DownloadIcon width={22} height={22} style={{ color: 'white' }} />}>
      <DownloadStepFileButton />
      <DownloadIndicationsPDF />
      {gatekeeper.feature.defectsReportWithScreenshots && (
        <DownloadDefectsReportWithScreenshots />
      )}
    </SubmenuComponent>
  )
}
